import { FC } from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdb-react-ui-kit";
import styles from "../../styles/detail/PersonalizeJourneyBanner.module.scss";

const PersonalizeJourneyBanner: FC = () => {
    return (
        <MDBContainer fluid className={styles.bannerContainer}>
            <div className={styles.bannerBackground} />
            <MDBRow className={styles.contentRow}>
                <MDBCol className={styles.contentColumn}>
                    <div className={styles.content}>
                        <div className={styles.ctaContent}>
                            <div className={styles.headline}>
                                <h2 className={styles.headlineText}>
                                    Would you like to{" "}
                                    <span className={styles.headlineGreen}>
                                        personalize this journey?
                                    </span>
                                </h2>
                                <p className={styles.description}>
                                    Every Play Italy itinerary can be tailored
                                    to your preferences: add extra days, adjust
                                    experiences, or include new destinations.{" "}
                                    <br />
                                    Tell us what you have in mind, and
                                    we&apos;ll refine this journey just for you.
                                </p>
                            </div>
                            <MDBBtn
                                className={styles.button}
                                onClick={() => {
                                    window.open(
                                        "https://hello.playitaly.com/#contact",
                                        "_blank"
                                    );
                                }}
                            >
                                <span className={styles.buttonLabel}>
                                    Plan Your Journey
                                </span>
                            </MDBBtn>
                        </div>
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    );
};

export default PersonalizeJourneyBanner;
